// Polyfill for Promise.withResolvers - needed for newer PDF.js versions
if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Export so it can be imported to ensure it runs
export default function initPolyfills() {
  // Polyfill is applied when this module is imported
}
